
import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

// Lazy load components
const HomePage = lazy(() => import('../pages/home/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const BellvillePage = lazy(() => import('../pages/bellville/page'));
const ParowPage = lazy(() => import('../pages/parow/page'));
const GoodwoodPage = lazy(() => import('../pages/goodwood/page'));
const ElsiesRiverPage = lazy(() => import('../pages/elsies-river/page'));
const KuilsRiverPage = lazy(() => import('../pages/kuils-river/page'));
const BrackenfellPage = lazy(() => import('../pages/brackenfell/page'));
const KraaifonteinPage = lazy(() => import('../pages/kraaifontein/page'));
const MilnertonPage = lazy(() => import('../pages/milnerton/page'));
const TableViewPage = lazy(() => import('../pages/table-view/page'));
const BloubergstrandPage = lazy(() => import('../pages/bloubergstrand/page'));

// Service pages
const InteriorPaintingPage = lazy(() => import('../pages/interior-painting/page'));
const ExteriorPaintingPage = lazy(() => import('../pages/exterior-painting/page'));
const RoofPaintingPage = lazy(() => import('../pages/roof-painting/page'));
const CommercialPaintingPage = lazy(() => import('../pages/commercial-painting/page'));
const ResidentialPaintingPage = lazy(() => import('../pages/residential-painting/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/contact',
    element: <ContactPage />,
  },
  {
    path: '/bellville-painters',
    element: <BellvillePage />,
  },
  {
    path: '/parow-painters',
    element: <ParowPage />,
  },
  {
    path: '/goodwood-painters',
    element: <GoodwoodPage />,
  },
  {
    path: '/elsies-river-painters',
    element: <ElsiesRiverPage />,
  },
  {
    path: '/kuils-river-painters',
    element: <KuilsRiverPage />,
  },
  {
    path: '/brackenfell-painters',
    element: <BrackenfellPage />,
  },
  {
    path: '/kraaifontein-painters',
    element: <KraaifonteinPage />,
  },
  {
    path: '/milnerton-painters',
    element: <MilnertonPage />,
  },
  {
    path: '/table-view-painters',
    element: <TableViewPage />,
  },
  {
    path: '/bloubergstrand-painters',
    element: <BloubergstrandPage />,
  },
  // Service pages
  {
    path: '/interior-painting',
    element: <InteriorPaintingPage />,
  },
  {
    path: '/exterior-painting',
    element: <ExteriorPaintingPage />,
  },
  {
    path: '/roof-painting',
    element: <RoofPaintingPage />,
  },
  {
    path: '/commercial-painting',
    element: <CommercialPaintingPage />,
  },
  {
    path: '/residential-painting',
    element: <ResidentialPaintingPage />,
  },
];

export default routes;
